/*
 * Public API Surface of catalean-configuration
 */

export * from './lib/catalean-config.service';
export * from './lib/catalean-config.module';

